import React, {useEffect, useState} from "react";
import { Box, Container, Grid, Typography, Switch, FormGroup, FormControlLabel, Button, useMediaQuery } from "@material-ui/core";
import useStyles from "./styles";
import featureSettingsActions from "./actions";
import { useSelector } from "react-redux";

const disableFeatureToggles = false;

const FeatureSettingsContainer = () => {
  const { features } = useSelector((state) => state.featureSettings);
  const [featureSetting, setFeatureSetting] = useState(features);
  const { getFeatureSettings, setFeatureSettings } = featureSettingsActions();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));
  const classes = useStyles();

  useEffect(() => {
    getFeatureSettings();
  }, []);

  useEffect(() => {
    setFeatureSetting(features)
  }, [features]);

  const toggleChecked = (e) => {
    setFeatureSetting((prevState) => {
        const updatedState = {
            ...prevState,
            [e.target.name]: e.target.checked
        };
        return updatedState;
    });
}
const saveChangesHandler = () => {
  setFeatureSettings(featureSetting)

}

  return (
    <Grid container className={classes.profileSection}>
      <Grid item xs={12} >
        <Container>
          <Box className={classes.headerContainer}>
            <Typography
              variant="h6"
              className={classes.heading}
              gutterBottom
            >
              Feature Settings
            </Typography>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={featureSetting["colarado_river_water_access"]}
                    name={"colarado_river_water_access"}
                    disabled={disableFeatureToggles}
                    color="primary"
                    onChange={toggleChecked}
                  />
                }
                label="Colorado River Water Access"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      featureSetting[
                        "central_arizona_colorado_river_water_access_per_person_municipal_areas"
                      ]
                    }
                    name={
                      "central_arizona_colorado_river_water_access_per_person_municipal_areas"
                    }
                    color="primary"
                    onChange={toggleChecked}
                    disabled={disableFeatureToggles}
                  />
                }
                label="Central Arizona Colorado River Water Access per Person Municipal Areas  "
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      featureSetting[
                        "central_arizona_water_deliveries_and_uses"
                      ]
                    }
                    name={"central_arizona_water_deliveries_and_uses"}
                    color="primary"
                    onChange={toggleChecked}
                    disabled={disableFeatureToggles}
                  />
                }
                label="Central Arizona Water Deliveries & Uses - 2020"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      featureSetting[
                        "colorado_river_access_by_water_priority_level"
                      ]
                    }
                    name={"colorado_river_access_by_water_priority_level"}
                    color="primary"
                    onChange={toggleChecked}
                    disabled={disableFeatureToggles}
                  />
                }
                label="Colorado River Water Access by Priority Level"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      featureSetting[
                        "central_arizona_colorado_river_water_use_vs_access"
                      ]
                    }
                    name={"central_arizona_colorado_river_water_use_vs_access"}
                    color="primary"
                    onChange={toggleChecked}
                    disabled={disableFeatureToggles}
                  />
                }
                label="Central Arizona Colorado River Water Use vs Access"
              />
            </FormGroup>
            <Box my = {3}>
              <Button
                fullWidth={!matches}
                variant="outlined"
                color="secondary"
                className={classes.cancelBtn}
                onClick={() => setFeatureSetting(features)}
              >
                Cancel
              </Button>

              <Button
                fullWidth={!matches}
                variant="contained"
                color="primary"
                className={classes.saveBtn}
                onClick={saveChangesHandler}
                disabled={Object.keys(featureSetting).every((value) => !featureSetting[value])}
              >
                Save Changes
              </Button>
            </Box>
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
};

export default FeatureSettingsContainer;
